<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="添加银行卡" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="625px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="70px">
        <el-form-item label="卡号：" prop="cardCode" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.cardCode" placeholder="请输入卡号" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称：" prop="cardName" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.cardName" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    saveCard
  } from '@/api/Card'
  import cookies from '../../../libs/util.cookies'
  export default {
    data() {
      return {
        form: {
          cardCode: '',
          cardName: ''
        },
        rules: {
          cardCode: [{
            required: true,
            message: "请输入卡号",
            trigger: "blur",
          }, ],
          cardName: [{
            required: true,
            message: "请输入名称",
            trigger: "blur",
          }, ]
        },
        loadBtn: false,
      };
    },
    created() {},
    methods: {
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        if (this.loadBtn) return;
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.loadBtn = true;
            const params = {
              ...this.form
            }
            const res = await saveCard(params);
            if (res.code === 200) {
              this.$message.success("添加成功");
              this.$emit("confirm");
            }
            this.loadBtn = false;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/CardManagement/components/AddCause.vue